// Country calling codes. Names match the country list on the Profile page
// so the saved `country` lines up with what users can pick there.
const dialCodes = [
  { iso: "AF", name: "Afghanistan", code: "+93" },
  { iso: "AL", name: "Albania", code: "+355" },
  { iso: "DZ", name: "Algeria", code: "+213" },
  { iso: "AD", name: "Andorra", code: "+376" },
  { iso: "AO", name: "Angola", code: "+244" },
  { iso: "AG", name: "Antigua and Barbuda", code: "+1268" },
  { iso: "AR", name: "Argentina", code: "+54" },
  { iso: "AM", name: "Armenia", code: "+374" },
  { iso: "AU", name: "Australia", code: "+61" },
  { iso: "AT", name: "Austria", code: "+43" },
  { iso: "AZ", name: "Azerbaijan", code: "+994" },
  { iso: "BS", name: "The Bahamas", code: "+1242" },
  { iso: "BH", name: "Bahrain", code: "+973" },
  { iso: "BD", name: "Bangladesh", code: "+880" },
  { iso: "BB", name: "Barbados", code: "+1246" },
  { iso: "BY", name: "Belarus", code: "+375" },
  { iso: "BE", name: "Belgium", code: "+32" },
  { iso: "BZ", name: "Belize", code: "+501" },
  { iso: "BJ", name: "Benin", code: "+229" },
  { iso: "BT", name: "Bhutan", code: "+975" },
  { iso: "BO", name: "Bolivia", code: "+591" },
  { iso: "BA", name: "Bosnia and Herzegovina", code: "+387" },
  { iso: "BW", name: "Botswana", code: "+267" },
  { iso: "BR", name: "Brazil", code: "+55" },
  { iso: "BN", name: "Brunei", code: "+673" },
  { iso: "BG", name: "Bulgaria", code: "+359" },
  { iso: "BF", name: "Burkina Faso", code: "+226" },
  { iso: "BI", name: "Burundi", code: "+257" },
  { iso: "CV", name: "Cabo Verde", code: "+238" },
  { iso: "KH", name: "Cambodia", code: "+855" },
  { iso: "CM", name: "Cameroon", code: "+237" },
  { iso: "CA", name: "Canada", code: "+1" },
  { iso: "CF", name: "Central African Republic", code: "+236" },
  { iso: "TD", name: "Chad", code: "+235" },
  { iso: "CL", name: "Chile", code: "+56" },
  { iso: "CN", name: "China", code: "+86" },
  { iso: "CO", name: "Colombia", code: "+57" },
  { iso: "KM", name: "Comoros", code: "+269" },
  { iso: "CD", name: "Congo, Democratic Republic of the", code: "+243" },
  { iso: "CG", name: "Congo, Republic of the", code: "+242" },
  { iso: "CR", name: "Costa Rica", code: "+506" },
  { iso: "CI", name: "Côte d’Ivoire", code: "+225" },
  { iso: "HR", name: "Croatia", code: "+385" },
  { iso: "CU", name: "Cuba", code: "+53" },
  { iso: "CY", name: "Cyprus", code: "+357" },
  { iso: "CZ", name: "Czech Republic", code: "+420" },
  { iso: "DK", name: "Denmark", code: "+45" },
  { iso: "DJ", name: "Djibouti", code: "+253" },
  { iso: "DM", name: "Dominica", code: "+1767" },
  { iso: "DO", name: "Dominican Republic", code: "+1809" },
  { iso: "TL", name: "East Timor (Timor-Leste)", code: "+670" },
  { iso: "EC", name: "Ecuador", code: "+593" },
  { iso: "EG", name: "Egypt", code: "+20" },
  { iso: "SV", name: "El Salvador", code: "+503" },
  { iso: "GQ", name: "Equatorial Guinea", code: "+240" },
  { iso: "ER", name: "Eritrea", code: "+291" },
  { iso: "EE", name: "Estonia", code: "+372" },
  { iso: "SZ", name: "Eswatini", code: "+268" },
  { iso: "ET", name: "Ethiopia", code: "+251" },
  { iso: "FJ", name: "Fiji", code: "+679" },
  { iso: "FI", name: "Finland", code: "+358" },
  { iso: "FR", name: "France", code: "+33" },
  { iso: "GA", name: "Gabon", code: "+241" },
  { iso: "GM", name: "The Gambia", code: "+220" },
  { iso: "GE", name: "Georgia", code: "+995" },
  { iso: "DE", name: "Germany", code: "+49" },
  { iso: "GH", name: "Ghana", code: "+233" },
  { iso: "GR", name: "Greece", code: "+30" },
  { iso: "GD", name: "Grenada", code: "+1473" },
  { iso: "GT", name: "Guatemala", code: "+502" },
  { iso: "GN", name: "Guinea", code: "+224" },
  { iso: "GW", name: "Guinea-Bissau", code: "+245" },
  { iso: "GY", name: "Guyana", code: "+592" },
  { iso: "HT", name: "Haiti", code: "+509" },
  { iso: "HN", name: "Honduras", code: "+504" },
  { iso: "HU", name: "Hungary", code: "+36" },
  { iso: "IS", name: "Iceland", code: "+354" },
  { iso: "IN", name: "India", code: "+91" },
  { iso: "ID", name: "Indonesia", code: "+62" },
  { iso: "IR", name: "Iran", code: "+98" },
  { iso: "IQ", name: "Iraq", code: "+964" },
  { iso: "IE", name: "Ireland", code: "+353" },
  { iso: "IL", name: "Israel", code: "+972" },
  { iso: "IT", name: "Italy", code: "+39" },
  { iso: "JM", name: "Jamaica", code: "+1876" },
  { iso: "JP", name: "Japan", code: "+81" },
  { iso: "JO", name: "Jordan", code: "+962" },
  { iso: "KZ", name: "Kazakhstan", code: "+7" },
  { iso: "KE", name: "Kenya", code: "+254" },
  { iso: "KI", name: "Kiribati", code: "+686" },
  { iso: "KP", name: "Korea, North", code: "+850" },
  { iso: "KR", name: "Korea, South", code: "+82" },
  { iso: "XK", name: "Kosovo", code: "+383" },
  { iso: "KW", name: "Kuwait", code: "+965" },
  { iso: "KG", name: "Kyrgyzstan", code: "+996" },
  { iso: "LA", name: "Laos", code: "+856" },
  { iso: "LV", name: "Latvia", code: "+371" },
  { iso: "LB", name: "Lebanon", code: "+961" },
  { iso: "LS", name: "Lesotho", code: "+266" },
  { iso: "LR", name: "Liberia", code: "+231" },
  { iso: "LY", name: "Libya", code: "+218" },
  { iso: "LI", name: "Liechtenstein", code: "+423" },
  { iso: "LT", name: "Lithuania", code: "+370" },
  { iso: "LU", name: "Luxembourg", code: "+352" },
  { iso: "MG", name: "Madagascar", code: "+261" },
  { iso: "MW", name: "Malawi", code: "+265" },
  { iso: "MY", name: "Malaysia", code: "+60" },
  { iso: "MV", name: "Maldives", code: "+960" },
  { iso: "ML", name: "Mali", code: "+223" },
  { iso: "MT", name: "Malta", code: "+356" },
  { iso: "MH", name: "Marshall Islands", code: "+692" },
  { iso: "MR", name: "Mauritania", code: "+222" },
  { iso: "MU", name: "Mauritius", code: "+230" },
  { iso: "MX", name: "Mexico", code: "+52" },
  { iso: "FM", name: "Micronesia", code: "+691" },
  { iso: "MD", name: "Moldova", code: "+373" },
  { iso: "MC", name: "Monaco", code: "+377" },
  { iso: "MN", name: "Mongolia", code: "+976" },
  { iso: "ME", name: "Montenegro", code: "+382" },
  { iso: "MA", name: "Morocco", code: "+212" },
  { iso: "MZ", name: "Mozambique", code: "+258" },
  { iso: "MM", name: "Myanmar", code: "+95" },
  { iso: "NA", name: "Namibia", code: "+264" },
  { iso: "NR", name: "Nauru", code: "+674" },
  { iso: "NP", name: "Nepal", code: "+977" },
  { iso: "NL", name: "Netherlands", code: "+31" },
  { iso: "NZ", name: "New Zealand", code: "+64" },
  { iso: "NI", name: "Nicaragua", code: "+505" },
  { iso: "NE", name: "Niger", code: "+227" },
  { iso: "NG", name: "Nigeria", code: "+234" },
  { iso: "MK", name: "North Macedonia", code: "+389" },
  { iso: "NO", name: "Norway", code: "+47" },
  { iso: "OM", name: "Oman", code: "+968" },
  { iso: "PK", name: "Pakistan", code: "+92" },
  { iso: "PW", name: "Palau", code: "+680" },
  { iso: "PA", name: "Panama", code: "+507" },
  { iso: "PG", name: "Papua New Guinea", code: "+675" },
  { iso: "PY", name: "Paraguay", code: "+595" },
  { iso: "PE", name: "Peru", code: "+51" },
  { iso: "PH", name: "Philippines", code: "+63" },
  { iso: "PL", name: "Poland", code: "+48" },
  { iso: "PT", name: "Portugal", code: "+351" },
  { iso: "QA", name: "Qatar", code: "+974" },
  { iso: "RO", name: "Romania", code: "+40" },
  { iso: "RU", name: "Russia", code: "+7" },
  { iso: "RW", name: "Rwanda", code: "+250" },
  { iso: "KN", name: "Saint Kitts and Nevis", code: "+1869" },
  { iso: "LC", name: "Saint Lucia", code: "+1758" },
  { iso: "VC", name: "Saint Vincent and the Grenadines", code: "+1784" },
  { iso: "WS", name: "Samoa", code: "+685" },
  { iso: "SM", name: "San Marino", code: "+378" },
  { iso: "ST", name: "Sao Tome and Principe", code: "+239" },
  { iso: "SA", name: "Saudi Arabia", code: "+966" },
  { iso: "SN", name: "Senegal", code: "+221" },
  { iso: "RS", name: "Serbia", code: "+381" },
  { iso: "SC", name: "Seychelles", code: "+248" },
  { iso: "SL", name: "Sierra Leone", code: "+232" },
  { iso: "SG", name: "Singapore", code: "+65" },
  { iso: "SK", name: "Slovakia", code: "+421" },
  { iso: "SI", name: "Slovenia", code: "+386" },
  { iso: "SB", name: "Solomon Islands", code: "+677" },
  { iso: "SO", name: "Somalia", code: "+252" },
  { iso: "ZA", name: "South Africa", code: "+27" },
  { iso: "ES", name: "Spain", code: "+34" },
  { iso: "LK", name: "Sri Lanka", code: "+94" },
  { iso: "SD", name: "Sudan", code: "+249" },
  { iso: "SS", name: "Sudan, South", code: "+211" },
  { iso: "SR", name: "Suriname", code: "+597" },
  { iso: "SE", name: "Sweden", code: "+46" },
  { iso: "CH", name: "Switzerland", code: "+41" },
  { iso: "SY", name: "Syria", code: "+963" },
  { iso: "TW", name: "Taiwan", code: "+886" },
  { iso: "TJ", name: "Tajikistan", code: "+992" },
  { iso: "TZ", name: "Tanzania", code: "+255" },
  { iso: "TH", name: "Thailand", code: "+66" },
  { iso: "TG", name: "Togo", code: "+228" },
  { iso: "TO", name: "Tonga", code: "+676" },
  { iso: "TT", name: "Trinidad and Tobago", code: "+1868" },
  { iso: "TN", name: "Tunisia", code: "+216" },
  { iso: "TR", name: "Turkey", code: "+90" },
  { iso: "TM", name: "Turkmenistan", code: "+993" },
  { iso: "TV", name: "Tuvalu", code: "+688" },
  { iso: "UG", name: "Uganda", code: "+256" },
  { iso: "UA", name: "Ukraine", code: "+380" },
  { iso: "AE", name: "United Arab Emirates", code: "+971" },
  { iso: "GB", name: "United Kingdom", code: "+44" },
  { iso: "US", name: "United States", code: "+1" },
  { iso: "UY", name: "Uruguay", code: "+598" },
  { iso: "UZ", name: "Uzbekistan", code: "+998" },
  { iso: "VU", name: "Vanuatu", code: "+678" },
  { iso: "VA", name: "Vatican City", code: "+39" },
  { iso: "VE", name: "Venezuela", code: "+58" },
  { iso: "VN", name: "Vietnam", code: "+84" },
  { iso: "YE", name: "Yemen", code: "+967" },
  { iso: "ZM", name: "Zambia", code: "+260" },
  { iso: "ZW", name: "Zimbabwe", code: "+263" },
];

// Regional indicator symbols turn an ISO code into its flag emoji.
export const flag = (iso) =>
  iso.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

export default dialCodes;
